import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function NorthIcon(props: IconProps) {
    return <Icon {...props} iconKey={"north"}/>
}
